import { styled } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const PackageFeatureInfoHolder = styled(Flex)`
    gap: 8px;
`;

export const Block = styled(Flex)`
    width: 100%;
    flex-direction: column;
    gap: 10px;
    padding: 8px;
    box-sizing: border-box;
    background-color: ${colorsPalettes.carbon[25]};
    border-radius: 8px;
    flex-grow: 1;
`;

export const FeatureList = styled(Flex)`
    flex-direction: column;
    gap: 6px;
`;

export const FeatureItem = styled(Flex)`
    align-items: center;
    gap: 4px;
`;
